import Flex from '../../generic/Flex';
import Icon, { type IconClassName } from '../../generic/Icon';
import { RouterLink } from '../../generic/Link';

import styles from './SummaryActionOption.module.less';

type SummaryActionOptionProps = {
  to: string;
  action: string;
  icon: IconClassName;
  iconHasSpin?: boolean;
  openInNewTab?: boolean;
};

/**
 * Component for rendering an nav action option found in a project summary page's Actions panel.
 * This component does not handle actions other than router navigation.
 *
 * @param {object} params The parameters for the component
 * @param {string} params.to - Where the user should be redirected to upon clicking the action button.
 * @param {string} params.action - The button label.
 * @param {IconClassName} params.icon - The icon to display.
 * @param {boolean} [params.iconHasSpin] - If the icon should rotate.
 * @param {boolean} [params.openInNewTab] - If the action button should open a new tab upon click.
 */
const SummaryActionOption = ({
  to,
  action,
  icon,
  iconHasSpin,
  openInNewTab = false,
}: SummaryActionOptionProps) =>
  <div className={styles.container}>
    <RouterLink to={to} openInNewTab={openInNewTab}>
      <Flex justify="flex-start" gap={6}>
        <div className={styles.iconContainer}>
          <Icon icon={icon} hasSpin={iconHasSpin} />
        </div>
        <div>{action}</div>
      </Flex>
    </RouterLink>
  </div>;

export default SummaryActionOption;
